const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamondIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    height: 27,
    id: "screenshot-ead713f5-05d7-80ac-8007-ba5935f81da5",
    viewBox: "2480 1234 28 27",
    style: {
      WebkitPrintColorAdjust: ":exact"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81da5",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    id: "render-22944-Layer_2",
    viewBox: "0 0 43.04 39.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "render-22944-Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91,7.07h0c-.13,0-.24-.08-.28-.2l-.57-1.86-1.86-.57c-.12-.04-.2-.15-.2-.28s.08-.24.2-.28l1.86-.57.57-1.86c.04-.12.15-.2.28-.2h0c.13,0,.24.08.28.2l.57,1.86,1.86.57c.12.04.2.15.2.28s-.08.24-.2.28l-1.86.57-.57,1.86c-.04.12-.15.2-.28.2Z",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7,4.16h0c-.13,0-.24-.08-.28-.21l-.37-1.22-1.22-.37c-.12-.04-.2-.15-.2-.28,0-.13.08-.24.2-.28l1.22-.38.37-1.22c.04-.12.15-.2.28-.2h0c.13,0,.24.08.28.2l.38,1.22,1.22.38c.12.04.2.15.2.28,0,.13-.08.24-.2.28l-1.22.37-.38,1.22c-.04.12-.15.2-.28.2Z",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.38,39.29L1.83,16.12l11.22.06,8.33,23.11ZM30.61,15.16H14.38l3.11-7.93h10.03l3.09,7.93ZM22.5,39.38l-8.19-23.21h16.37l-8.18,23.21ZM43.04,16.17l-19.43,23.21,8.15-23.21h11.28ZM31.74,15.16l-3.12-7.93,7.51.03,6.91,7.9h-11.3ZM16.41,7.25l-3.36,7.91H1.83l1.04-1.16,5.99-6.74h7.55Z",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "render-22944-Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91,7.07h0c-.13,0-.24-.08-.28-.2l-.57-1.86-1.86-.57c-.12-.04-.2-.15-.2-.28s.08-.24.2-.28l1.86-.57.57-1.86c.04-.12.15-.2.28-.2h0c.13,0,.24.08.28.2l.57,1.86,1.86.57c.12.04.2.15.2.28s-.08.24-.2.28l-1.86.57-.57,1.86c-.04.12-.15.2-.28.2Z",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7,4.16h0c-.13,0-.24-.08-.28-.21l-.37-1.22-1.22-.37c-.12-.04-.2-.15-.2-.28,0-.13.08-.24.2-.28l1.22-.38.37-1.22c.04-.12.15-.2.28-.2h0c.13,0,.24.08.28.2l.38,1.22,1.22.38c.12.04.2.15.2.28,0,.13-.08.24-.2.28l-1.22.37-.38,1.22c-.04.12-.15.2-.28.2Z",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.38,39.29L1.83,16.12l11.22.06,8.33,23.11ZM30.61,15.16H14.38l3.11-7.93h10.03l3.09,7.93ZM22.5,39.38l-8.19-23.21h16.37l-8.18,23.21ZM43.04,16.17l-19.43,23.21,8.15-23.21h11.28ZM31.74,15.16l-3.12-7.93,7.51.03,6.91,7.9h-11.3ZM16.41,7.25l-3.36,7.91H1.83l1.04-1.16,5.99-6.74h7.55Z",
    style: {
      fill: "#794c8a",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81da6",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81da6"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 2480,
    y: 1234,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    width: 28,
    height: 27,
    fill: "none",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81da7"
  }, /*#__PURE__*/React.createElement("defs", {
    style: {
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81da8",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81da9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81da9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2481.89306640625,1238.84765625L2481.89306640625,1238.84765625C2481.80859375,1238.84765625,2481.737060546875,1238.79248046875,2481.7109375,1238.71044921875L2481.34033203125,1237.43505859375L2480.130126953125,1237.0439453125C2480.052001953125,1237.0166015625,2480,1236.94140625,2480,1236.8525390625C2480,1236.76318359375,2480.052001953125,1236.6875,2480.130126953125,1236.66015625L2481.34033203125,1236.26953125L2481.7109375,1234.994140625C2481.737060546875,1234.912109375,2481.80859375,1234.85693359375,2481.89306640625,1234.85693359375L2481.89306640625,1234.85693359375C2481.977783203125,1234.85693359375,2482.04931640625,1234.912109375,2482.0751953125,1234.994140625L2482.446044921875,1236.26953125L2483.656005859375,1236.66015625C2483.734130859375,1236.6875,2483.7861328125,1236.76318359375,2483.7861328125,1236.8525390625C2483.7861328125,1236.94140625,2483.734130859375,1237.0166015625,2483.656005859375,1237.0439453125L2482.446044921875,1237.43505859375L2482.0751953125,1238.71044921875C2482.04931640625,1238.79248046875,2481.977783203125,1238.84765625,2481.89306640625,1238.84765625Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81daa"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81daa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2485.65966796875,1236.8525390625L2485.65966796875,1236.8525390625C2485.5751953125,1236.8525390625,2485.503662109375,1236.79736328125,2485.4775390625,1236.7080078125L2485.237060546875,1235.8720703125L2484.443359375,1235.6181640625C2484.365234375,1235.5908203125,2484.31298828125,1235.51513671875,2484.31298828125,1235.42578125C2484.31298828125,1235.3369140625,2484.365234375,1235.26171875,2484.443359375,1235.234375L2485.237060546875,1234.9736328125L2485.4775390625,1234.13671875C2485.503662109375,1234.0546875,2485.5751953125,1234,2485.65966796875,1234L2485.65966796875,1234C2485.744384765625,1234,2485.81591796875,1234.0546875,2485.842041015625,1234.13671875L2486.08935546875,1234.9736328125L2486.8828125,1235.234375C2486.9609375,1235.26171875,2487.012939453125,1235.3369140625,2487.012939453125,1235.42578125C2487.012939453125,1235.51513671875,2486.9609375,1235.5908203125,2486.8828125,1235.6181640625L2486.08935546875,1235.8720703125L2485.842041015625,1236.7080078125C2485.81591796875,1236.79052734375,2485.744384765625,1236.845703125,2485.65966796875,1236.845703125Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ead713f5-05d7-80ac-8007-ba5935f81dab"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ead713f5-05d7-80ac-8007-ba5935f81dab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2493.908935546875,1260.9384765625L2481.190673828125,1245.052734375L2488.48974609375,1245.09326171875L2493.908935546875,1260.9384765625ZM2499.913818359375,1244.39404296875L2489.35498046875,1244.39404296875L2491.37841796875,1238.95703125L2497.9033203125,1238.95703125L2499.913818359375,1244.39404296875ZM2494.637451171875,1261L2489.309326171875,1245.08642578125L2499.959228515625,1245.08642578125L2494.637451171875,1261ZM2508,1245.08642578125L2495.359619140625,1261L2500.66162109375,1245.08642578125L2508,1245.08642578125ZM2500.648681640625,1244.39404296875L2498.619140625,1238.95703125L2503.504638671875,1238.9775390625L2508,1244.39404296875L2500.648681640625,1244.39404296875ZM2490.675537109375,1238.970703125L2488.48974609375,1244.39404296875L2481.190673828125,1244.39404296875L2481.8671875,1243.5986328125L2485.763916015625,1238.9775390625L2490.675537109375,1238.9775390625Z",
    style: {
      strokeWidth: 0,
      fill: "#794c8a"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondIcon);
export default __webpack_public_path__ + "static/media/diamondIcon.d17ce91557c2c24f5493e76ffd153156.svg";
export { ForwardRef as ReactComponent };